import { a } from '../global-constants';

export const setIncentives = (payload) => {
	return {
		type: a.SET_INCENTIVES,
		payload
	};
};
